export const categories = ({categories}) => categories



// WEBPACK FOOTER //
// ./src/app/config/store/modules/categories/getters.js